import axios from 'axios'
import { AUTH_TOKEN } from '../config/LSvars'
import { basicAuthPassword, basicAuthUsername } from '../config/config'

export const setAuthToken = (token) => {
  const newToken = token || localStorage.getItem(AUTH_TOKEN)
  if (newToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
  } else {
    deleteAuthToken()
  }
}

export const deleteAuthToken = () => {
  axios.defaults.headers.common['Authorization'] = null
}

export const setBasicAuth = () => {
  axios.defaults.headers.common['Authorization'] =
    `Basic ${btoa(`${basicAuthUsername}:${basicAuthPassword}`)}`
}
